import React, { Component } from "react";
import Carousel from "react-multi-carousel";
import { Redirect } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import actionHandler from "../../../base/utils/action_handler";

class DynamicBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responsive: {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 1,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
    };
  }

  render() {
    return (
      <div className="row mx-0 mb-5 px-4" dir="ltr">
        {this.state.actionUrl && <Redirect push to={this.state.actionUrl} />}
        <div
          style={{
            color: this.props.view.title_color,
            fontSize: this.props.view.title_size + "px",
          }}
          className={`col-12 px-0 text-end mb-2 fw-bold`}
        >
          {this.props.view.title}
        </div>
        <div
          className="col-12 px-0 position-relative"
          style={{
            paddingTop:
              (this.props.view.ratio.split(":")[1] /
                this.props.view.ratio.split(":")[0]) *
                100 +
              "%",
          }}
        >
          <Carousel
            className="position-absolute top-0 bottom-0 start-0 end-0 rounded14"
            autoPlay={false}
            responsive={this.state.responsive}
            showDots={this.props.view.items.length === 1 ? false : true}
            infinite={false}
            draggable={true}
            swipeable={true}
            keyBoardControl={true}
            arrows={false}
            sliderClass="h-100"
            renderDotsOutside
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style bottom-n30"
          >
            {this.props.view.items?.map((item, i) => (
              <div
                className="col-12 px-0 w-100 h-100 img-cover position-relative"
                onClick={() =>
                  item.action &&
                  this.setState({
                    actionUrl: actionHandler(
                      item.action,
                      item.action_data,
                      item.title
                    ),
                  })
                }
              >
                <Image
                  extraClassName={"p-0 img-contain"}
                  imgClassName={"w-100 h-100 rounded14 img-cover"}
                  imageUri={item.media && item.media.file}
                />
                {item.title && (
                  <div
                    className="shop-card-grad position-absolute"
                    style={{ top: "0", left: "0", right: "0", bottom: "0" }}
                  >
                    <p
                      className="fs-5 mb-0 text-white text-center position-absolute"
                      style={{ bottom: "5px", right: "0", left: "0" }}
                    >
                      {item.title}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    );
  }
}

export default DynamicBanner;
